// @flow

import type {ApplicationState} from '../../types'
import type {MapState} from '../types'

export function getGoogleMap(appState: ApplicationState): ?GoogleMap{
  return _getGoogleMap(appState.map) 
}

function _getGoogleMap(state: MapState): ?GoogleMap {
  return state.googleMap
}

getGoogleMap.internal = _getGoogleMap
